import React from "react"

type ButtonType = "primary" | "upgrade"
interface IProps {
  title?: string
  description?: string
  showIcon: boolean
  linkText?: string
  linkUrl?: string
  buttonLabel?: string
  showBackgroundImage?: boolean
  buttonType?: ButtonType
  onButtonClick?: () => void
  isLoading?: boolean
}

const imgSrc = `../../assets/img/free-version.png`

const RestrictedAccess = (props: IProps) => {
  return (
    <div
      className="d-flex h-100 flex-column justify-content-center align-items-center text-center text-muted"
      data-testid="missingLicensediv"
      style={{ backgroundColor: "rgba(229, 240, 248, 1)" }}
    >
      <div
        className="bg-gray_0 d-block rounded d-flex justify-content-center align-items-center mb-1"
        style={{ width: "192px", height: "192px" }}
      >
        <img src={imgSrc} alt="Lock Icon" className="popup-icon" />
      </div>
      <h1 className="mb-1">{props.title}</h1>
      <p>{props.description}</p>
      {props.buttonLabel && (
        <button
          className={`button mt-3 ${props.buttonType ? props.buttonType : "primary"}`}
          onClick={props.onButtonClick}
        >
          {props.buttonLabel}
        </button>
      )}
    </div>
  )
}

export default RestrictedAccess
